export const NEWS_FULL = [
  {
    id: 1,
    slug: "bando-isi-inail-lazio-2025",
    titolo: "Bando ISI INAIL Lazio 2025: contributi a fondo perduto per salute e sicurezza sul lavoro",
    data: "9 Febbraio 2026",
    categoria: "Bandi e credito",
    categorie: ["Bandi e credito"],
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80&auto=format",
    excerpt: "Contributi a fondo perduto fino al 65% per le imprese del Lazio che investono in salute e sicurezza sul lavoro. Domande dal 1 marzo 2026.",
    contenuto: `<p>Il <strong>Bando ISI INAIL Lazio 2025</strong> e un programma di <strong>finanziamenti a fondo perduto</strong> per sostenere le imprese che investono nel miglioramento dei livelli di salute e sicurezza nei luoghi di lavoro. La domanda deve essere presentata esclusivamente in modalità telematica a partire dal <strong>1 marzo 2026</strong>.</p>
<p>Il contributo copre il <strong>65%</strong> dell'intervento, per progetti con importo compreso tra <strong>5.000 e 130.000 euro</strong>.</p>
<h3>Progetti ammissibili: cosa puoi finanziare</h3>
<p>L'impresa può presentare un unico progetto, che riguardi una sola tipologia di investimento tra i seguenti Assi di finanziamento:</p>
<ul>
<li><strong>Asse 1.1</strong> - Riduzione dei rischi tecnopatici (rischio chimico, rumore, vibrazioni, movimentazione)</li>
<li><strong>Asse 1.2</strong> - Modelli organizzativi e responsabilità sociale (ISO 45001, D.Lgs. 81/2008)</li>
<li><strong>Asse 2</strong> - Riduzione dei rischi infortunistici (caduta dall'alto, spazi confinati)</li>
<li><strong>Asse 3</strong> - Bonifica amianto</li>
<li><strong>Asse 4</strong> - Progetti per micro e piccole imprese in settori specifici</li>
</ul>
<h3>Beneficiari: requisiti principali</h3>
<ul>
<li>Iscrizione al Registro Imprese (CCIAA) da almeno 12 mesi</li>
<li>Sede legale e operativa nel Lazio</li>
<li>DURC regolare</li>
<li>Iscrizione INAIL e INPS</li>
</ul>
<h3>Assistenza Promo.Ter Confcommercio Roma</h3>
<p>Confcommercio Roma, tramite Promo.Ter, offre un servizio di assistenza per la presentazione della domanda. <strong>Per gli associati la fase di pre-ammissibilità e verifica dei requisiti è gratuita.</strong></p>`,
    correlati: [2, 10, 5],
  },
  {
    id: 2,
    slug: "saldi-invernali-roma-2026-incassi-record",
    titolo: "Saldi invernali a Roma: incassi record e ritorno ai negozi fisici. Un bilancio da 600 milioni.",
    data: "5 Febbraio 2026",
    categoria: "Notizie",
    categorie: ["Notizie", "Federazione Moda Italia Roma"],
    image: "/news-saldi-invernali.png",
    excerpt: "A un mese dall'inizio delle svendite, la Capitale registra un aumento del 10% del fatturato. Volano gli acquisti di capi di qualità e di marca.",
    contenuto: `<p><strong>A un mese dall'inizio delle svendite, la Capitale registra un aumento del 10% del fatturato rispetto allo scorso anno. Volano gli acquisti di capi di qualità e di marca, mentre l'online rallenta a favore dello shopping nelle vie storiche.</strong></p>
<p>I saldi invernali 2026 segnano un punto di svolta per il commercio romano. Dopo anni caratterizzati dal predominio degli acquisti digitali, i consumatori hanno scelto di tornare in massa negli esercizi "fisici", premiando la qualità e l'affidabilita del punto vendita tradizionale.</p>
<p>Secondo le stime diffuse da <strong>Confcommercio Roma</strong>, il primo mese di sconti si chiude con un bilancio estremamente positivo: un giro d'affari complessivo che supera i <strong>600 milioni di euro</strong> sul territorio cittàdino, con una crescita media del <strong>10%</strong> rispetto al 2025.</p>
<h3>La riscossa del negozio fisico e della qualità</h3>
<p>Il dato più significativo e l'inversione di tendenza rispetto all'e-commerce. Come sottolineato da <strong>Massimo Bertoni</strong>, presidente di Federazione Moda Italia Roma, l'afflusso nei negozi e migliorato sensibilmente, specialmente per chi propone articoli di fascia alta o medio-alta.</p>
<h3>Cosa comprano i romani</h3>
<ul>
<li><strong>Capi spalla:</strong> Giacconi e cappotti sono stati i prodotti più richiesti</li>
<li><strong>Accessori e calzature:</strong> Buone performance con acquisti più ragionati</li>
<li><strong>Capi di marca:</strong> La quota di capi griffati e salita al 26,6%</li>
</ul>
<h3>Spesa media e zone dello shopping</h3>
<p>La spesa media pro capite si e attestata tra i <strong>130 e i 160 euro</strong>. Il Tridente (via del Corso, via del Babuino e via di Ripetta) ha guidato la ripresa insieme a via Cola di Rienzo e via Appia Nuova.</p>`,
    correlati: [3, 8, 11],
  },
  {
    id: 3,
    slug: "sentiment-imprese-terziario-roma-2025",
    titolo: "Il sentiment delle imprese del terziario di Roma Capitale 2025: rapporto di ricerca",
    data: "4 Febbraio 2026",
    categoria: "Notizie",
    categorie: ["Notizie"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80&auto=format",
    excerpt: "Cresce la fiducia delle imprese del terziario di Roma. Il 28% segnala un miglioramento e il 40% prevede crescita nel 2026-2027.",
    contenuto: `<p>Cresce la fiducia delle imprese del terziario di Roma Capitale. E quanto emerge dalla ricerca realizzata da <strong>Confcommercio Roma</strong> in collaborazione con <strong>Format Research</strong>, con il contributo della Camera di Commercio di Roma.</p>
<h3>Fiducia nell'andamento dell'attività economica</h3>
<p>Quasi il <strong>28% delle imprese</strong> segnala un miglioramento dell'andamento della propria attività economica, una quota nettamente superiore alla media nazionale (12%). Guardando al <strong>2026-2027</strong>, il <strong>40,4%</strong> prevede un ulteriore miglioramento.</p>
<h3>Occupazione: stabilita e lieve crescita</h3>
<p>Il <strong>71,4%</strong> delle imprese dichiara addetti rimasti invariati, mentre il <strong>15%</strong> prevede un aumento dell'occupazione nel 2026.</p>
<h3>Investimenti: formazione e innovazione al centro</h3>
<p>Il <strong>34,2%</strong> delle imprese ha investito nel 2025. Le priorità: formazione del personale (65,9%), attrezzature (64,7%), marketing (56,5%), digitalizzazione (55,3%).</p>
<h3>Ostacoli: pesa la burocrazia</h3>
<p>Il principale freno è la complessità burocratica e normativa (29%), seguita dai costi elevati (28,6%) e dal rischio d'impresa (28,1%).</p>`,
    correlati: [2, 9, 11],
  },
  {
    id: 4,
    slug: "confcommercio-roma-castelli-romani",
    titolo: "Confcommercio Roma vicina al territorio dei Castelli Romani",
    data: "3 Febbraio 2026",
    categoria: "Rappresentanza",
    categorie: ["Rappresentanza"],
    image: "/news-castelli-romani.jpeg",
    excerpt: "Il Direttore Romolo Guasco ospite da Rinascita Imprese per parlare di vicinanza al territorio dei Castelli Romani.",
    contenuto: `<p>Il Direttore di Confcommercio Roma, <strong>Romolo Guasco</strong>, è stato ospite dell'emittente locale <strong>Rinascita Imprese</strong> per illustrare le iniziative dell'Associazione a sostegno del tessuto imprenditoriale dei Castelli Romani.</p>
<p>Durante l'intervista, Guasco ha sottolineato l'importanza della presenza capillare sul territorio e la volontà di Confcommercio Roma di essere sempre più vicina alle esigenze delle imprese della provincia.</p>`,
    correlati: [6, 9, 12],
  },
  {
    id: 5,
    slug: "musica-ambiente-2026-diritti-connessi",
    titolo: "Musica d'Ambiente 2026: Nuove modalità di incasso per i Diritti Connessi",
    data: "3 Febbraio 2026",
    categoria: "Convenzioni",
    categorie: ["Convenzioni"],
    image: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800&q=80&auto=format",
    excerpt: "Aggiornamento sulle nuove modalità di incasso per i diritti connessi alla musica d'ambiente negli esercizi commerciali.",
    contenuto: `<p>Dal 2026 cambiano le modalità di incasso dei <strong>Diritti Connessi</strong> per la diffusione di musica d'ambiente negli esercizi commerciali. Confcommercio Roma informa gli associati sulle novità e sulle convenzioni disponibili per gestire correttamente gli adempimenti.</p>`,
    correlati: [7, 1, 12],
  },
  {
    id: 6,
    slug: "confcommercio-nuovo-logo-2025",
    titolo: "Confcommercio cambia volto: un nuovo logo per le sfide del futuro",
    data: "28 Gennaio 2026",
    categoria: "Rappresentanza",
    categorie: ["Rappresentanza"],
    image: "/news-nuovo-logo.jpg",
    excerpt: "A 16 anni dall'ultimo restyling, Confcommercio presenta il nuovo logo istituzionale: lineare, essenziale, moderno.",
    contenuto: `<p>Il 2026 segna un punto di svolta per tutto il sistema Confcommercio. A sedici anni dall'ultimo restyling, l'Organizzazione rinnova la propria identità visiva, presentando un <strong>nuovo logo istituzionale</strong> che unisce eredità storica e slancio verso il domani.</p>
<h3>Un simbolo che evolve, una storia che continua</h3>
<p>Il nuovo logo è <strong>lineare, essenziale e moderno</strong>: una scelta stilistica che riflette la volontà di adottare un linguaggio immediato, capace di parlare con chiarezza sia alle imprese storiche sia alle nuove generazioni.</p>
<p>Come ha sottolineato il Presidente Nazionale <strong>Carlo Sangalli</strong>: <em>"Il nuovo logo, lineare, essenziale, moderno, non è solo un esercizio estetico: è il segno visibile di una grande Organizzazione che traguarda il domani senza perdere le sue radici"</em>.</p>
<h3>Un'unica identità per tutto il Sistema</h3>
<p>Il rebranding coinvolge l'intero ecosistema Confederale: dalle Federazioni alle articolazioni territoriali. Per <strong>Confcommercio Roma</strong>, questo passaggio ha un significato profondo.</p>`,
    correlati: [4, 9, 11],
  },
  {
    id: 7,
    slug: "rentri-consulenza-gratuita-confcommercio-roma",
    titolo: "RENTRI: usufruisci della consulenza gratuita di Confcommercio Roma",
    data: "27 Gennaio 2026",
    categoria: "Servizi",
    categorie: ["Servizi"],
    image: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&q=80&auto=format",
    excerpt: "Consulenza online gratuita sul Registro Elettronico Nazionale per la Tracciabilità dei Rifiuti per gli associati.",
    contenuto: `<p>Il RENTRI (Registro Elettronico Nazionale per la Tracciabilita dei Rifiuti) e il nuovo sistema che accompagna la transizione verso una gestione più informatizzata degli adempimenti ambientali.</p>
<p>Confcommercio Roma, insieme a Promo.Ter, mette a disposizione degli associati una <strong>consulenza online gratuita</strong> per verificare l'applicabilità della normativa e ricevere indicazioni pratiche.</p>
<h3>Cosa cambia per le imprese</h3>
<ul>
<li><strong>Registro cronologico di carico e scarico rifiuti:</strong> aggiornati modelli e modalità con progressiva digitalizzazione</li>
<li><strong>Formulario di Identificazione del Rifiuto (FIR):</strong> nuove regole e formati telematici</li>
</ul>
<h3>Chi riguarda</h3>
<ul>
<li>Produttori di rifiuti pericolosi</li>
<li>Imprese che trattano rifiuti</li>
<li>Chi trasporta o intermedia rifiuti pericolosi</li>
</ul>`,
    correlati: [1, 5, 12],
  },
  {
    id: 8,
    slug: "saldi-invernali-2026-incassi-piu-10",
    titolo: "Saldi invernali 2026: incassi +10% e fiducia nei negozi fisici",
    data: "26 Gennaio 2026",
    categoria: "Notizie",
    categorie: ["Notizie", "Federazione Moda Italia Roma"],
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80&auto=format",
    excerpt: "Bertoni: Chi lavora nell'alta gamma non può essere scontento. Crescita a doppia cifra per lo shopping romano.",
    contenuto: `<p>I primi dati sui saldi invernali 2026 a Roma sono estremamente positivi, con una crescita degli incassi stimata intorno al <strong>+10%</strong> rispetto allo scorso anno.</p>
<p><strong>Massimo Bertoni</strong>, presidente di Federazione Moda Italia Roma, commenta: "Chi lavora nell'alta gamma non può essere scontento. Il ritorno dei consumatori nei negozi fisici e un segnale forte di fiducia nella qualità e nel servizio del commercio tradizionale".</p>`,
    correlati: [2, 11, 3],
  },
  {
    id: 9,
    slug: "inflazione-roma-2025-dato-piu-basso",
    titolo: "Inflazione a Roma: nel 2025 il dato più basso degli ultimi cinque anni",
    data: "20 Gennaio 2026",
    categoria: "Notizie",
    categorie: ["Notizie", "Rappresentanza"],
    image: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800&q=80&auto=format",
    excerpt: "Guasco: Smentite le ipotesi di speculazione per il Giubileo. I prezzi nella Capitale sono in linea con il dato nazionale.",
    contenuto: `<p>L'inflazione a Roma nel 2025 si è attestata su livelli storicamente bassi, smentendo le ipotesi di speculazione legate al Giubileo.</p>
<p>Il Direttore di Confcommercio Roma, <strong>Romolo Guasco</strong>, ha sottolineato come i dati dimostrino che il tessuto commerciale della Capitale ha agito con responsabilità, mantenendo prezzi in linea con il dato nazionale nonostante l'evento giubilare.</p>`,
    correlati: [3, 11, 4],
  },
  {
    id: 10,
    slug: "accordi-innovazione-2025-contributi",
    titolo: "Accordi per l'Innovazione 2025: contributi fino a 40 milioni per ricerca e sviluppo",
    data: "19 Gennaio 2026",
    categoria: "Bandi e credito",
    categorie: ["Notizie", "Bandi e credito"],
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&q=80&auto=format",
    excerpt: "Contributi significativi per le imprese che investono in ricerca, sviluppo e innovazione tecnologica.",
    contenuto: `<p>Il Ministero delle Imprese e del Made in Italy ha lanciato gli <strong>Accordi per l'Innovazione 2025</strong>, un programma di incentivi che mette a disposizione contributi fino a <strong>40 milioni di euro</strong> per progetti di ricerca e sviluppo.</p>
<p>I finanziamenti sono destinati a imprese di tutte le dimensioni che intendono realizzare progetti di ricerca industriale e sviluppo sperimentale con significativo impatto tecnologico.</p>`,
    correlati: [1, 7, 3],
  },
  {
    id: 11,
    slug: "commercio-roma-consumi-saldi-rilancio",
    titolo: "Commercio a Roma: Guasco traccia il quadro tra consumi, saldi e rilancio del centro",
    data: "5 Gennaio 2026",
    categoria: "Notizie",
    categorie: ["Notizie", "Rappresentanza"],
    image: "https://images.unsplash.com/photo-1569154941061-e231b4725ef1?w=800&q=80&auto=format",
    excerpt: "Il Direttore di Confcommercio Roma fa il punto su consumi, saldi invernali e rilancio del centro storico.",
    contenuto: `<p>Il Direttore di Confcommercio Roma, <strong>Romolo Guasco</strong>, ha tracciato il quadro del commercio nella Capitale all'inizio del 2026, tra l'avvio dei saldi invernali e le prospettive di rilancio del centro storico.</p>
<p>Tra i temi affrontati: l'andamento dei consumi, le aspettative per la stagione dei saldi e le iniziative per rivitalizzare il tessuto commerciale del centro storico di Roma.</p>`,
    correlati: [2, 8, 9],
  },
  {
    id: 12,
    slug: "sicurezza-esercizi-commerciali-protocollo",
    titolo: "Sicurezza degli esercizi commerciali: firmato il Protocollo d'intesa",
    data: "9 Dicembre 2025",
    categoria: "Notizie",
    categorie: ["Notizie", "Servizi"],
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&auto=format",
    excerpt: "Protocollo tra Prefettura, Confcommercio Roma e Confesercenti per rafforzare la sicurezza degli esercizi commerciali.",
    contenuto: `<p>E stato firmato un importante <strong>Protocollo d'intesa</strong> tra la Prefettura di Roma, Confcommercio Roma e Confesercenti per il rafforzamento della sicurezza degli esercizi commerciali nel territorio della Capitale.</p>
<p>L'accordo prevede una serie di misure coordinate per prevenire e contrastare i fenomeni di criminalita che colpiscono il commercio, con particolare attenzione alle zone più esposte.</p>`,
    correlati: [4, 9, 6],
  },
];
